module.exports = __webpack_public_path__ + "assets/images/project/constituencies/marymount-smc.jpg?v=6446bdef";